<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="s_tabs_box">
    <el-tab-pane :disabled="!isover" :label="'报名'+'('+signNum01+')'" name="报名"></el-tab-pane>
    <el-tab-pane :disabled="!isover" :label="'待面试'+'('+signNum02+')'" name="待面试"></el-tab-pane>
    <el-tab-pane :disabled="!isover" :label="'待入职'+'('+signNum03+')'" name="待入职"></el-tab-pane>
    <el-tab-pane :disabled="!isover" :label="'待离职'+'('+signNum08+')'" name="待离职"></el-tab-pane>
    <!-- <el-tab-pane :disabled="!isover" :label="'通过'+'('+signNum04+')'" name="通过"></el-tab-pane> -->
    <el-tab-pane :disabled="!isover" :label="'流程入职'+'('+signNum05+')'" name="在职"></el-tab-pane>
    <el-tab-pane :disabled="!isover" :label="'异常'+'('+signNum06+')'" name="异常"></el-tab-pane>
    <el-tab-pane :disabled="!isover" :label="'流程离职'+'('+signNum07+')'" name="离职"></el-tab-pane>
    <el-tab-pane :disabled="!isover" label="项目列表" v-if="checkPermission(['signupList_tab_roster'],authLists)" name="项目列表"></el-tab-pane>
    <el-tab-pane :disabled="!isover" label="花名册列表" v-if="checkPermission(['signupList_tab_roster'],authLists)" name="花名册列表"></el-tab-pane>
    <!-- <el-tab-pane :disabled="!isover" label="流程记录" name="流程记录"></el-tab-pane> -->
    <el-tab-pane v-if="noteCanView == 'true'" :disabled="!isover" label="消息通知记录" name="消息通知记录"></el-tab-pane>
    <!-- <el-tab-pane :disabled="!isover" label="个人资源" name="个人资源"></el-tab-pane> -->
    <!-- <el-tab-pane :disabled="!isover" v-if="roleType == 'adminuser'||roleType == 'adminusers'||roleType == 'recdirec'" label="公海资源" name="公海资源"></el-tab-pane> -->
    <!-- <el-tab-pane :disabled="!isover" label="导入导出记录" name="导入导出记录"></el-tab-pane> -->
  </el-tabs>
</template>
<script>
  import xz from "./../../../common.vue";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    props: {
      listQuerys: {
        type: Object,
        default () {
          return {}
        }
      },
      btnAuth: {
        type: Array,
        default () {
          return []
        }
      }
    },
    // props:["listQuerys"],
    data() {
      return {
        activeName: '报名',
        isover: true,
        roleType: localStorage.loginRoletype,
        numQuery: {
          StrnowState: '已报名', //状态
          strProjectName: '', // 项目名称
          strUserName: '', // 姓名
          strMobile: '', // 联系方式
          strJobInf: '', //岗位
          strSource: '', //来源
          strreuser: '', //招聘顾问
          strUserkf: '', //客服
          stroutid: '', //导出选中id
          currpage: 1, // 分页
          perpage: 10,
          strSourcejl: '', //简历来源
          posCategoryList: [], //意向岗位
          jobList: [], // 人岗匹配岗位
          roletype: localStorage.loginRoletype
        },
        // 按钮权限列表
        authLists: [],
        noteNum: 0,
        noteCanView: 'fasle',
        signNum01: 0, // 报名数量
        signNum02: 0, // 已约面数量
        signNum03: 0, // 到面数量
        signNum04: 0, // 通过数量
        signNum05: 0, // 在职数量
        signNum06: 0, // 异常数量
        signNum07: 0, // 离职数量
        signNum08: 0 // 待离职数量
      }
    },
    created() {
      // console.log('yy',this.btnAuth)
      if (!this.isNull(this.$route.query.active)) {
        this.activeName = this.$route.query.active
      } else {
        this.activeName = '报名'
      }
      if (this.activeName == '报名') {
        this.listQuerys.StrnowState = '已报名'
      } else if (this.activeName == '已约面') {
        this.listQuerys.StrnowState = '约面'
      } else if (this.activeName == '待面试') {
        this.listQuerys.StrnowState = '待面试'
      } else if (this.activeName == '待入职') {
        this.listQuerys.StrnowState = '待入职'
      } else if (this.activeName == '在职') {
        this.listQuerys.StrnowState = '入职'
      } else if (this.activeName == '异常') {
        this.listQuerys.StrnowState = '未到面,未通过,未入职'
      } else if (this.activeName == '离职') {
        this.listQuerys.StrnowState = '离职'
      } else if (this.activeName == '待离职') {
        this.listQuerys.StrnowState = '待离职'
      }
      if (location.pathname.indexOf('/signupList') > -1) {
        this.numQuery = this.listQuerys
        this.numQuery.currpage = 1
      }
      this.authLists = this.btnAuth
      this.getNoteNum()
      this.getSignNum()
      // 向父组件传值
      this.$emit('change', this.activeName);
    },
    watch: {
      '$store.state.resourceComTabsIsover': function () {
        this.isover = this.$store.state.resourceComTabsIsover
        //   console.log('d',this.isover)
      }
    },
    methods: {
      checkPermission,
      // 获取流程数量
      getSignNum() {
        xz.getsignResumecount(this.numQuery).then(res => {
          if (res.status == 'ok') {
            // console.log('rr',res)
            this.signNum01 = res.msg.signcont
            this.signNum02 = res.msg.tobeintercont
            this.signNum03 = res.msg.tobeentrycont
            this.signNum04 = res.msg.adoptcont
            this.signNum05 = res.msg.onjobcont
            this.signNum06 = res.msg.abnorcont
            this.signNum07 = res.msg.quitcont
            this.signNum08 = res.msg.waitquitcont
          }
        })
      },
      // 父组件获取数据
      getCanViewVal() {
        return this.noteCanView
      },
      // 父组件获取数据
      getNumVal() {
        return this.noteNum
      },
      // 获取用户可用短信数量 判断是否有通知权限
      getNoteNum() {
        xz.getsmsavailablenum('', localStorage.loginRoletype).then(res => {
          // console.log('rr',res)
          if (res.status == 'ok') {
            this.noteNum = res.data
            this.noteCanView = 'true'
          } else {
            this.noteNum = 0
            this.noteCanView = 'false'
          }
        })
      },
      handleClick(tab, event) {
        // 向父组件传递了两个值
        this.$emit('change', tab.name);
        if (tab.name == '报名') {
          this.listQuerys.StrnowState = '已报名'
          this.$router.push({
            path: '/signupList?active=报名'
          })
        } else if (tab.name == '待面试') {
          this.listQuerys.StrnowState = '待面试'
          this.$router.push({
            path: '/signupList?active=待面试'
          })
        } else if (tab.name == '待入职') {
          this.listQuerys.StrnowState = '待入职'
          this.$router.push({
            path: '/signupList?active=待入职'
          })
        } else if (tab.name == '已约面') {
          this.listQuerys.StrnowState = '约面'
          this.$router.push({
            path: '/signupList?active=已约面'
          })
        } else if (tab.name == '到面') {
          this.listQuerys.StrnowState = '到面'
          this.$router.push({
            path: '/signupList?active=到面'
          })
        } else if (tab.name == '通过') {
          this.listQuerys.StrnowState = '通过'
          this.$router.push({
            path: '/signupList?active=通过'
          })
        } else if (tab.name == '在职') {
          this.listQuerys.StrnowState = '入职'
          this.$router.push({
            path: '/signupList?active=在职'
          })
        } else if (tab.name == '异常') {
          this.listQuerys.StrnowState = '未到面,未通过,未入职'
          this.$router.push({
            path: '/signupList?active=异常'
          })
        } else if (tab.name == '离职') {
          this.listQuerys.StrnowState = '离职'
          this.$router.push({
            path: '/signupList?active=离职'
          })
        } else if (tab.name == '流程记录') {
          this.$router.push({
            path: '/processRecord?active=流程记录'
          })
        } else if (tab.name == '消息通知记录') {
          this.$router.push({
            path: '/noteSendList?active=消息通知记录'
          })
        } else if (tab.name == '项目列表') {
          this.$router.push({
            path: '/empRosterList?active=项目列表'
          })
        } else if (tab.name == '花名册列表') {
          this.$router.push({
            path: '/empRosterPerson?active=花名册列表'
          })
        } else if (tab.name == '待离职') {
          this.listQuerys.StrnowState = '待离职'
          this.$router.push({
            path: '/signupList?active=待离职'
          })
        }
        this.numQuery = this.listQuerys
        this.numQuery.currpage = 1
        this.getSignNum();
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
      }
    }
  }
</script>